var _path, _path2, _path3, _path4, _path5, _path6, _mask, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProcess04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.8922 39.6C77.8922 60.3851 61.2181 77.2 40.6922 77.2C20.1663 77.2 3.49219 60.3851 3.49219 39.6C3.49219 18.8149 20.1663 2 40.6922 2C61.2181 2 77.8922 18.8149 77.8922 39.6Z",
    stroke: "#222222",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9429 50.0801C18.9896 60.5634 29.1631 68 41.0736 68C56.5376 68 69.0736 55.464 69.0736 40C69.0736 24.536 56.5376 12 41.0736 12C27.6265 12 16.3935 21.4792 13.692 34.12C13.6194 34.46 13.5529 34.8023 13.4927 35.1468",
    stroke: "#222222",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.914 40.6519C13.7189 40.9223 13.3163 40.9223 13.1212 40.6519L9.20541 35.2261C8.9721 34.9028 9.2031 34.4512 9.6018 34.4512L17.4334 34.4512C17.8321 34.4512 18.0631 34.9028 17.8297 35.2261L13.914 40.6519Z",
    fill: "#222222"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.291 58H61.091",
    stroke: "#222222",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0947 26.6928C30.1918 26.5517 30.4002 26.5517 30.4973 26.6928L35.9751 34.6486C36.0868 34.8107 35.9707 35.0316 35.7738 35.0316H34.0211C33.9397 35.0316 33.894 35.1253 33.944 35.1895L38.1597 40.5965C38.2848 40.757 38.1705 40.9912 37.9669 40.9912H33.9802C33.8959 40.9912 33.8511 41.0908 33.9071 41.1539L40.3349 48.3937C40.4749 48.5514 40.363 48.8004 40.1522 48.8004H20.4398C20.229 48.8004 20.1171 48.5514 20.2571 48.3937L26.6849 41.1539C26.7409 41.0908 26.6961 40.9912 26.6118 40.9912H22.625C22.4215 40.9912 22.3072 40.757 22.4323 40.5965L26.648 35.1895C26.698 35.1253 26.6523 35.0316 26.5709 35.0316H24.8182C24.6213 35.0316 24.5052 34.8107 24.6169 34.6486L30.0947 26.6928Z",
    stroke: "#222222",
    strokeWidth: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4961 49V58",
    stroke: "#222222",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-1_217_1423",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.1634 26.2036C56.1634 26.8757 56.0681 27.5243 55.8911 28.1352C59.1067 28.6251 61.5829 31.6676 61.5829 35.3477C61.5829 38.8681 59.317 41.805 56.3055 42.4821C55.5995 44.9028 53.0743 46.6939 50.0674 46.6939C47.0214 46.6939 44.4698 44.8559 43.8027 42.3874C40.9759 41.563 38.8921 38.7236 38.8921 35.3477C38.8921 31.9153 41.0461 29.0376 43.945 28.2683C43.7424 27.6187 43.6327 26.9247 43.6327 26.2036C43.6327 22.5563 46.4378 19.5996 49.8981 19.5996C53.3583 19.5996 56.1634 22.5563 56.1634 26.2036Z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8911 28.1352L53.0096 27.3004C52.7692 28.1301 52.8982 29.0232 53.3635 29.7511C53.8288 30.479 54.5853 30.9709 55.4393 31.101L55.8911 28.1352ZM56.3055 42.4821L55.6474 39.5551C54.5821 39.7946 53.7311 40.594 53.4254 41.6422L56.3055 42.4821ZM43.8027 42.3874L46.6989 41.6049C46.426 40.595 45.6469 39.8003 44.6427 39.5074L43.8027 42.3874ZM43.945 28.2683L44.7145 31.1679C45.5052 30.9581 46.1759 30.4345 46.5713 29.7184C46.9667 29.0022 47.0525 28.1557 46.8089 27.3748L43.945 28.2683ZM58.7726 28.9701C59.0277 28.0896 59.1634 27.16 59.1634 26.2036H53.1634C53.1634 26.5913 53.1086 26.9589 53.0096 27.3004L58.7726 28.9701ZM64.5829 35.3477C64.5829 30.3856 61.2137 25.9115 56.3429 25.1695L55.4393 31.101C56.9997 31.3387 58.5829 32.9495 58.5829 35.3477H64.5829ZM56.9635 45.409C61.5007 44.3889 64.5829 40.1044 64.5829 35.3477H58.5829C58.5829 37.6317 57.1333 39.2211 55.6474 39.5551L56.9635 45.409ZM50.0674 49.6939C54.187 49.6939 58.0479 47.2228 59.1855 43.322L53.4254 41.6422C53.1511 42.5827 51.9616 43.6939 50.0674 43.6939V49.6939ZM40.9066 43.17C41.9843 47.1584 45.8981 49.6939 50.0674 49.6939V43.6939C48.1448 43.6939 46.9552 42.5535 46.6989 41.6049L40.9066 43.17ZM44.6427 39.5074C43.2251 39.094 41.8921 37.5299 41.8921 35.3477H35.8921C35.8921 39.9173 38.7267 44.032 42.9628 45.2674L44.6427 39.5074ZM41.8921 35.3477C41.8921 33.1258 43.2702 31.5512 44.7145 31.1679L43.1755 25.3687C38.822 26.524 35.8921 30.7048 35.8921 35.3477H41.8921ZM40.6327 26.2036C40.6327 27.2299 40.7889 28.2251 41.0812 29.1618L46.8089 27.3748C46.6958 27.0123 46.6327 26.6194 46.6327 26.2036H40.6327ZM49.8981 16.5996C44.6341 16.5996 40.6327 21.0502 40.6327 26.2036H46.6327C46.6327 24.0624 48.2415 22.5996 49.8981 22.5996V16.5996ZM59.1634 26.2036C59.1634 21.0502 55.162 16.5996 49.8981 16.5996V22.5996C51.5546 22.5996 53.1634 24.0624 53.1634 26.2036H59.1634Z",
    fill: "#222222",
    mask: "url(#path-7-inside-1_217_1423)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.729 31.2832V57.6992",
    stroke: "#222222",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6915 33.6992L50.2368 35.4993",
    stroke: "#222222",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7915 36.4004L49.2208 39.6951",
    stroke: "#222222",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProcess04);
export default __webpack_public_path__ + "static/media/icon_process_04.3a1b87328df7e818526bc80634e68042.svg";
export { ForwardRef as ReactComponent };